import * as React from 'react';
import ReactModal from 'react-modal';

import { modalBackdrop, modalCard, modalHeader, reactModalBody } from './modal.styles';

export interface ModalProps {
  className?: string;
  onRequestClose: () => void;
  children: React.ReactNode;
  title?: React.ReactNode;
  isOpen: boolean;
}

export const Modal = ({
  className = '',
  onRequestClose,
  children,
  title = '',
  isOpen,
}: ModalProps) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      className={`react-modal ${className}`}
      overlayClassName={modalBackdrop}
      portalClassName="react-modal-portal"
    >
      <div className={`react-modal-card ${modalCard}`}>
        <div className={`react-modal-header ${title ? modalHeader : ''}`}>
          <span>{title}</span>
        </div>
        <div className={reactModalBody}>{children}</div>
      </div>
    </ReactModal>
  );
};
